import { apiRequest, ajaxWatched } from '../../shared/services';
import { userAuthenticated } from "../../shared/actions/user";

//export const LOCATE_FETCH_BY_COLLECTION = 'LOCATE_FETCH_BY_COLLECTION';
export const LOCATE_RECEIVED_AUTH_TOKEN = 'LOCATE_RECEIVED_AUTH_TOKEN';
export const LOCATE_SUCCEEDED = 'LOCATE_SUCCEEDED';
export const LOCATE_FAILED = 'LOCATE_FAILED';

function receiveAuthToken(authToken, emailedTo){
    return {
        type: LOCATE_RECEIVED_AUTH_TOKEN,
        authToken: authToken,
        emailedTo: emailedTo
    }
}

export function fetchLocateByCollection(collectionId, emailAddress) {
    var rt = {};
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState,'/api/auth-request/' + collectionId, {
                method: 'POST',
                body: JSON.stringify({emailAddress: emailAddress})
            })
            .then(json => dispatch(receiveAuthToken(json.tokenId, emailAddress)))
        ));
    }
}

function receiveAuthTokenRedemption(json) {
    if (json.success) {
        return {
            type: LOCATE_SUCCEEDED,
            collectionId: json.collectionId
        };
    } else
    {
        return {
            type: LOCATE_FAILED,
            failureReason: json.reason
        };
    }
}

export function redeemAuthToken(authToken, secret) {
    var rt = {};
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/auth-redeem/' + authToken, {
                method: 'POST',
                body: JSON.stringify({secret: secret})
            })
            .then(json => {
                if (json.success && json.authInfo !== undefined) {
                    dispatch(userAuthenticated(json.authInfo));
                }
                dispatch(receiveAuthTokenRedemption(json));
            })
        ));
    }
}
